module.exports = "<div class=\"toast-window\" *ngIf=\"show\">\n  <div class=\"toast-message\">{{ message }}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/components/toast/toast.component.html
// module id = ../../../../../src/app/core/components/toast/toast.component.html
// module chunks = main